import { isTypeProgramComparisonSection } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulProgramComparisonSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeProgramComparisonSection(entry)) {
    return null;
  }

  return <div>ContentfulProgramComparisonSection</div>;
};

export default ContentfulProgramComparisonSection;
